import consumer from './consumer'

const createAiChatChannel = (conversationId, callbacks = {}) => {
  const {
    onMessageReceived,
    onStreamDelta,
    onStreamComplete,
    onToolStatus,
    onError,
    onConnected,
    onDisconnected
  } = callbacks

  const subscription = consumer.subscriptions.create(
    {
      channel: 'AiChatChannel',
      conversation_id: conversationId
    },
    {
      connected() {
        console.log('Connected to AiChatChannel')
        if (onConnected) onConnected()
      },

      disconnected() {
        console.log('Disconnected from AiChatChannel')
        if (onDisconnected) onDisconnected()
      },

      received(data) {
        console.log('Received:', data)

        switch (data.type) {
          case 'message_received':
            if (onMessageReceived) onMessageReceived(data)
            break
          case 'stream_delta':
            if (onStreamDelta) onStreamDelta(data.content)
            break
          case 'stream_complete':
            if (onStreamComplete) onStreamComplete(data)
            break
          case 'tool_status':
            if (onToolStatus) onToolStatus(data)
            break
          case 'error':
            if (onError) onError(data.message)
            break
          default:
            console.log('Unknown message type:', data.type)
        }
      },

      sendMessage(content) {
        this.perform('send_message', { content })
      }
    }
  )

  return subscription
}

export default createAiChatChannel
